import cn from 'classnames';
import { PropsWithChildren } from 'react';
// import styled from 'styled-components';

// export const Flex = styled.div`
//   display: flex;
//   height: calc(100vh - 225px);
// `;

// export const SidebarContainer = styled.div`
//   width: 6rem;
// `;

// export const SidebarItem = styled.div`
//   padding: 0.75rem 0.25rem;
//   text-align: center;
//   background-color: #efefef;
//   &.active {
//     background: #fff;
//   }
//   .image {
//     margin: 0 auto 0.5rem;
//     width: 2rem;
//     height: 2rem;
//     overflow: hidden;
//   }
//   .text {
//     overflow: hidden;
//     text-overflow: ellipsis;
//     font-size: 0.625rem;
//     line-height: 1rem;
//     max-height: 2rem;
//   }
// `;

// export const SidebarWrapper = styled.div`
//   width: 6rem;
//   overflow-y: scroll;
// `;

// export const ContentWrapper = styled.div`
//   background-color: #fff;
//   flex: 1 0 0;
//   overflow-y: scroll;
// `;

// export const ContentContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap;
// `;

// export const ContentItem = styled.a`
//   width: 33.33333%;
//   box-sizing: border-box;
//   text-decoration: none;
//   color: rgba(0, 0, 0, 0.87);
//   text-align: center;
//   height: 6.625rem;
//   padding: 0.5rem;
//   .image {
//     height: 2.5rem;
//     width: 2.5rem;
//     margin: 0 auto 0.25rem;
//   }
//   .text {
//     overflow: hidden;
//     display: -webkit-box;
//     text-overflow: ellipsis;
//     -webkit-box-orient: vertical;
//     -webkit-line-clamp: 3;
//     line-height: 0.875rem;
//     height: 2.625rem;
//     font-weight: 400;
//     font-size: 0.75rem;
//   }
// `;

// export const ContentLink = styled.a`
//   display: block;
//   margin: 0.5rem;
//   text-align: right;
//   font-weight: 500;
//   color: var(--primary);
//   path {
//     fill: var(--primary);
//   }
// `;

export const Flex: PropsWithChildren<any> = ({ className, ...other }) => (
  <div className={cn('sitemap', className)} {...other} />
);

export const SidebarWrapper: PropsWithChildren<any> = ({
  className,
  ...other
}) => <div className={cn('sidebar-wrapper', className)} {...other} />;

export const SidebarContainer: PropsWithChildren<any> = ({
  className,
  ...other
}) => <div className={cn('sidebar-container', className)} {...other} />;

export const SidebarItem: PropsWithChildren<any> = ({
  className,
  ...other
}) => <div className={cn('sidebar-container__item', className)} {...other} />;

export const ContentWrapper: PropsWithChildren<any> = ({
  className,
  ...other
}) => <div className={cn('content-wrapper', className)} {...other} />;

export const ContentContainer: PropsWithChildren<any> = ({
  className,
  ...other
}) => <div className={cn('content-container', className)} {...other} />;

export const ContentItem: PropsWithChildren<any> = ({
  className,
  ...other
}) => <a className={cn('content-container__item', className)} {...other} />;

export const ContentLink: PropsWithChildren<any> = ({
  className,
  ...other
}) => <a className={cn('content-container__link', className)} {...other} />;

export const HelperLink: PropsWithChildren<any> = ({ className, ...other }) => (
  <div className={cn(className)} style={{ display: 'none' }} {...other} />
);
